import { StyledCheckbox } from '@ui';
import moment from 'moment';
import { FC } from 'react';
import { useController, useFormContext } from 'react-hook-form';

interface Props {
    name: string;
}

const WeekdayInput: FC<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({ name }) => {
    const { control } = useFormContext();
    const {
        field: { value, onChange }
    } = useController({ name, control });
    const weekdays = moment.weekdays();
    weekdays.push(weekdays.shift());

    const handleChange = (index: number) => {
        let newValue = value ?? [];
        if (newValue.includes(index)) {
            newValue = newValue.filter((day) => day !== index);
        } else {
            newValue.push(index);
        }

        onChange(newValue);
    };

    return (
        <div className="tw-flex tw-justify-around tw-gap-2">
            {weekdays.map((day, index) => (
                <div key={day} className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1">
                    <StyledCheckbox
                        isSelected={(value ?? []).includes(index)}
                        defaultChecked={(value ?? []).includes(index)}
                        onChange={() => handleChange(index)}
                    />
                    <span>{day.substring(0, 2)}</span>
                </div>
            ))}
        </div>
    );
};

export default WeekdayInput;
